import { render, staticRenderFns } from "./CapitalRecord.vue?vue&type=template&id=66ea1189&scoped=true&"
import script from "./CapitalRecord.vue?vue&type=script&lang=js&"
export * from "./CapitalRecord.vue?vue&type=script&lang=js&"
import style0 from "./CapitalRecord.vue?vue&type=style&index=0&id=66ea1189&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ea1189",
  null
  
)

export default component.exports